import { SOFTWARE_CATALOG_ENDPOINT } from "Constants";
import { ExternalCatalogPackage, ExternalCatalogPackageRequest } from "Types";
import { baseApi } from "./base.api";

export const externalCatalogApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getExternalCatalogPackage: build.query<
      ExternalCatalogPackage,
      ExternalCatalogPackageRequest
    >({
      query: (queryArg) => ({
        url: `${SOFTWARE_CATALOG_ENDPOINT}/external/${queryArg.catalog}/software/${queryArg.externalPackageId}`,
        params: {
          group_id: queryArg.groupId,
        },
      }),
    }),
  }),
});

export const { useGetExternalCatalogPackageQuery } = externalCatalogApi;
